import React, { useEffect, useMemo, useState } from "react";
import DashboardHeader from "../../../../components/header/DashboardHeader";
import "../createGroup/CreateGroup.css";
import { Link, useNavigate } from "react-router-dom";
import { Input, Select, TextArea } from "../../../../components/header/form";
import { imageHandler } from "../../../../utils/imageHandler";
import { upload_cover } from "../../../../assets";
import { createGroupApi } from "../../../../services/groups";
import multipartDataHelper from "../../../../utils/sendMultipartDataHelper";
import { fetchCategoriesListApi } from "../../../../services/common";
import { toastMessage } from "../../../../utils/toastMessage";
import { Button } from "components/form";
import useButtonLoader from "hooks/useButtonLoader";
import { provideOnlyNumbers } from "utils/commonHelper";
import { useSelector } from "react-redux";

const CreateGroup = () => {
  const { showAuth } = useSelector((state) => state?.showAuth);

  const [submitButtonElement, setSubmitLoading] = useButtonLoader();

  const [categoryList, setCategoryList] = useState([]);
  const [inputData, setInputData] = useState({
    name: "",
    categoryName: "",
    type: "",
    description: "",
    monthlyPrice: "",
    quarterlyPrice: "",
    yearlyPrice: "",
  });
  const [image, setImage] = useState("");
  const navigate = useNavigate();

  const {
    name,
    categoryName,
    type,
    description,
    monthlyPrice,
    quarterlyPrice,
    yearlyPrice,
  } = inputData;

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (["monthlyPrice", "quarterlyPrice", "yearlyPrice"].includes(name)) {
      setInputData({ ...inputData, [name]: provideOnlyNumbers(value) });
    } else {
      setInputData({ ...inputData, [name]: value.replace(/^\s+/, "") });
    }
  };

  const isButtonDisabled = useMemo(() => {
    if (name && categoryName && type && description) {
      if (type === "SUBSCRIPTION") {
        if (monthlyPrice && quarterlyPrice && yearlyPrice) {
          return false;
        }
      } else {
        return false;
      }
    }
    return true;
  }, [
    name,
    categoryName,
    type,
    description,
    monthlyPrice,
    quarterlyPrice,
    yearlyPrice,
  ]);

  //   Fetching Category List
  const fetchCategoryList = async () => {
    try {
      const { data } = await fetchCategoriesListApi();
      const { success, data: response } = data;
      if (success) {
        setCategoryList(response);
      } else {
        setCategoryList([]);
      }
    } catch (e) {
      console.log("Error:-", e.message);
    }
  };
  // ----------create-group----------------
  const addGroupHandler = async () => {
    if (!image?.name) {
      return toastMessage(
        "please upload cover image",
        "error",
        "coverImageCreateGroup"
      );
    }
    try {
      setSubmitLoading(true);
      const formData = new FormData();
      formData.append("coverImage", image);

      let payload = {
        name,
        categoryName,
        type,
        description,
      };

      if (type === "SUBSCRIPTION") {
        payload = {
          ...payload,
          monthlyPrice,
          quarterlyPrice,
          yearlyPrice,
        };
      }

      [showAuth._id].forEach((id) => {
        formData.append("_user", id);
      });
      multipartDataHelper(formData, payload);

      const { data } = await createGroupApi(formData);
      const { success, message } = data;
      if (success) {
        navigate(-1);
      }
      toastMessage(message, success ? "success" : "error", "addGroupHandler");
    } catch (e) {
      console.log("Error:-", e.message);
    } finally {
      setSubmitLoading(false);
    }
  };

  useEffect(() => {
    fetchCategoryList();
  }, []);

  return (
    <>
      <DashboardHeader title={"Groups"} />

      <div className="dashboard_pages">
        <div className="create_group">
          <div className="create_group_page">
            <div className="create_grp_Navbar">
              <nav className="breadcrumb_wrap">
                <ul>
                  <li className="has_arrow">
                    <Link to={-1}>Groups </Link>
                  </li>
                  <li>
                    <span>Create a Group</span>
                  </li>
                </ul>
              </nav>
            </div>

            <div className="upload_cover">
              <div className="upload_design">
                <label className="user_icon" htmlFor="file_picker">
                  <div className="upload_design_content">
                    <img
                      src={
                        (image?.name && URL.createObjectURL(image)) ||
                        upload_cover
                      }
                      alt=""
                    />
                    <div className="upload_design_text">
                      <h3>Upload Cover</h3>
                      <span>(JPG, GIF, PNG. Max size of 800K)</span>
                    </div>
                  </div>
                  <input
                    type="file"
                    id="file_picker"
                    accept="image/*"
                    onChange={(e) => imageHandler(e, setImage, "image", null)}
                  />
                  <label
                    htmlFor="profile_picture"
                    className="edit-icon"
                  ></label>
                </label>
              </div>

              <div className="form_field_wrap has_three">
                <div className="form_field">
                  <Input
                    required
                    label="Group Name"
                    type="text"
                    id="name"
                    name="name"
                    value={inputData?.name}
                    onChange={handleChange}
                    className="input form-control"
                    placeholder="Enter Group Name"
                  />
                </div>

                <div className="form_field">
                  <Select
                    label="Category"
                    type="text"
                    id="categoryName"
                    name="categoryName"
                    value={inputData?.categoryName}
                    onChange={handleChange}
                    className="input form-control"
                  >
                    <option value="">Select Category</option>
                    {categoryList?.map((data, ind) => (
                      <option key={ind} value={data?.name}>
                        {data?.name}
                      </option>
                    ))}
                  </Select>
                </div>

                <div className="form_field">
                  <Select
                    label="Group Type"
                    type="text"
                    id="groupType"
                    name="type"
                    value={inputData?.type}
                    onChange={handleChange}
                    className="input form-control"
                  >
                    <option value={""}>Group Type</option>
                    <option value={"PRIVATE"}>Private</option>
                    <option value={"PUBLIC"}>Public</option>
                    <option value={"SUBSCRIPTION"}>Subscription</option>
                  </Select>
                </div>
              </div>
              {/* -------------if-subscription------------------- */}
              {inputData?.type === "SUBSCRIPTION" && (
                <>
                  <div className="form_field_wrap">
                    <div className="form_field">
                      <Input
                        required
                        label="Monthly"
                        type="text"
                        id="monthly"
                        name="monthlyPrice"
                        value={inputData?.monthlyPrice}
                        onChange={handleChange}
                        className="input form-control"
                        placeholder="Enter enter monthly"
                      />
                    </div>

                    <div className="form_field">
                      <Input
                        required
                        label="Quarterly"
                        type="text"
                        id="quarterly"
                        name="quarterlyPrice"
                        value={inputData?.quarterlyPrice}
                        onChange={handleChange}
                        className="input form-control"
                        placeholder="Enter enter quarterly"
                      />
                    </div>

                    <div className="form_field">
                      <Input
                        required
                        label="Yearly"
                        type="text"
                        id="yearly"
                        name="yearlyPrice"
                        value={inputData?.yearlyPrice}
                        onChange={handleChange}
                        className="input form-control"
                        placeholder="Enter enter yearly"
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="form_field_wrap">
                <div className="form_field textarea">
                  <TextArea
                    label="Description"
                    type="text"
                    id="description"
                    name="description"
                    value={inputData?.description}
                    onChange={handleChange}
                    className="input form-control"
                    placeholder="Write here..."
                    // error={error?.nickname}
                    rows="6"
                  />
                </div>
              </div>
              <div className="button_wrap button_left">
                <Button
                  onClick={addGroupHandler}
                  {...submitButtonElement}
                  disabled={isButtonDisabled || submitButtonElement.disabled}
                >
                  Create Group
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateGroup;
